<template>
    <div class="options" id="about">
        <div class="options__container container">
            <div class="options__left">
                <div class="options__left-title"
                    v-html="isMobile ?
                        `У нас есть всё для вашего комфорта!` :
                        `У нас есть всё для <br>вашего комфорта!`
                    "
                >
                </div>
                <Btn
                    @clickDef="$emit('scrollTo', 'form')"
                    class="options__left-btn"
                    :text="`Узнать подробности`"
                    :mode="`red`"
                />
            </div>
            <div class="options__right">
<!--                <div class="options__right-title">-->
<!--                    <strong>PESOK</strong> - это первый в Красноярске центр пляжных видов спорта!<br>На нашей территории в 1100 кв.м. расположились:-->
<!--                </div>-->
                <ul class="options__right-list">
                    <div class="_box" v-for="(option, ind) in adv" :key="ind">
                        <li class="options__right-list-el">{{ option.title }}</li>
                        <li class="options__right-list-el-add">
                            {{ option.description }}
                        </li>
                    </div>
                </ul>
            </div>

            <Btn
                @clickDef="$emit('scrollTo', 'form')"
                class="options__right-btn-mob"
                :text="`Узнать подробности`"
                :mode="`red`"
            />
        </div>
    </div>
</template>

<script>
import Btn from './blocks/Btn';

export default {
    name: "ThirdBlockOptions",
    components: {
        Btn
    },
    props: {
        adv: {}
    },
    computed: {
        isMobile() {
            return window.innerWidth < 768
        }
    },
    mounted() {
        const list = document.querySelector('.options__right-list');

        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animation');
                }
            });
        });

        observer.observe(list);
    }
}
</script>

<style scoped lang="scss">
.options {
    position: relative;
    background: #FFFFFF;
    color: #000;
    overflow: hidden;
    padding-bottom: 20px;

    @include below($mobile) {
        padding-bottom: 10px;
    }

    &:before {
        position: absolute;
        content: '';
        bottom: 0;
        width: 100%;
        height: 20px;
        background: linear-gradient(90deg, #4961F9 0%, #FF4747 49.33%, #FFB72A 100.76%);
        z-index: 1;

        @include below($mobile) {
            height: 10px;
        }
    }

    &:after {
        position: absolute;
        content: '';
        width: 840px;
        height: 840px;
        right: 50px;
        bottom: -150px;
        background: url("data:image/svg+xml,%3Csvg width='625' height='840' viewBox='-215 0 840 840' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M-208.622 492.735C-194.537 502.867 -179.594 512.616 -163.952 521.856C-129.739 542.072 -93.2843 559.159 -55.6071 572.641C45.1625 608.703 151.964 618.552 262.002 601.962C264.709 613.338 267.133 624.201 269.265 634.195C274.958 660.862 279.359 686.472 282.39 710.528C183.13 725.365 86.493 717.774 -5.01268 687.91C-82.1026 662.755 -139.097 627.149 -173.893 601.142C-180.654 587.017 -186.627 572.481 -191.799 557.562C-199.162 536.318 -204.771 514.67 -208.622 492.735ZM-214.346 398.214C-212.73 366.927 -207.724 336.276 -199.403 306.526C-183.776 318.019 -154.022 337.066 -104.908 358.397C-66.3429 375.142 -24.2386 389.956 23.7742 403.679C80.6633 420.161 128.472 429.824 165.871 432.396C182.464 433.534 193.507 432.976 200.131 432.224C203.992 437.612 210.919 448.593 219.621 468.086C234.433 501.273 246.825 541.962 256.479 579.571C150.969 595.149 48.6396 585.562 -47.8677 551.025C-127.269 522.61 -184.205 483.38 -212.969 460.733C-214.964 440.076 -215.431 419.211 -214.346 398.214ZM-175.499 242.032C-151.729 191.124 -118.334 146.063 -76.2424 108.104C-34.1522 70.1453 14.1068 41.5669 67.1936 23.1622C105.605 9.8451 145.326 2.24635 185.729 0.451419C149.404 19.7716 106.004 47.6986 62.1201 87.1535C61.8762 87.3734 61.6418 87.5848 61.3983 87.8044C-12.2633 154.235 -68.7718 236.505 -106.702 332.476C-139.109 317.742 -161.211 304.645 -174.453 295.91C-182.628 290.521 -188.416 286.154 -192.129 283.173C-187.33 269.226 -181.788 255.505 -175.499 242.032ZM236.962 1.26708C275.334 4.18401 312.699 12.2322 348.545 25.2736C311.645 41.9696 258.11 71.0886 203.26 117.815C198.689 121.714 194.181 125.664 189.733 129.676C115.001 197.072 57.9767 280.721 19.9978 378.676C-18.7823 367.263 -53.5282 355.08 -85.6384 341.646C-49.0173 248.673 5.57729 169.057 76.7724 104.851C77.0025 104.643 77.2369 104.432 77.4674 104.224C137.793 49.9861 197.076 18.4098 236.962 1.26708ZM505.115 126.394C487.306 134.2 455.965 150.452 413.069 182.257C389.609 199.652 365.797 219.264 340.933 241.687C330.649 250.962 320.181 260.722 309.489 270.998C266.768 312.054 234.487 348.647 213.543 379.759C204.245 393.571 199.203 403.417 196.536 409.522C190.914 410.08 180.66 410.534 164.602 409.279C141.734 407.49 102.349 401.794 42.1625 385.035C81.0211 285.685 140.182 201.709 218.149 135.292C282.386 80.567 344.604 50.9771 378.454 37.4733C379.88 38.1202 381.301 38.771 382.722 39.4352C428.57 60.8384 469.671 90.0542 505.115 126.394ZM601.572 282.106C619.348 333.388 626.934 386.999 624.12 441.452C621.305 495.906 608.236 548.452 585.274 597.633C582.812 602.899 580.244 608.102 577.58 613.244C579.035 572.074 576.589 520.489 564.426 462.814C543.873 365.34 500.824 274.849 436.41 193.655C465.355 172.946 487.757 160.352 501.948 153.25C510.612 148.918 517.242 146.1 521.68 144.376C557.13 185.101 583.996 231.399 601.572 282.106ZM474.731 741.382C478.731 701.071 480.283 640.192 467.267 569.379C447.938 464.203 402.803 366.985 333.055 280.247C362.763 252.104 390.688 228.111 417.944 207.319C480.392 285.858 522.1 373.354 541.962 467.553C558.671 546.798 556.349 614.017 551.242 657.213C532.652 684.295 510.851 709.165 486.017 731.562C482.304 734.911 478.541 738.183 474.731 741.382ZM308.819 826.651C310.979 807.373 312.607 772.081 306.5 718.896C303.415 691.004 298.442 660.898 291.716 629.403C276.11 556.216 258.431 497.742 239.178 455.607C230.08 435.71 222.633 424.039 217.998 417.756C220.33 412.607 225.071 403.499 234.19 390.219C247.187 371.299 271.836 340.013 316.447 296.242C383.047 379.573 426.177 472.801 444.688 573.531C459.937 656.505 454.442 725.165 449.202 761.249C416.494 784.738 380.788 803.256 342.581 816.503C331.431 820.37 320.171 823.747 308.819 826.651ZM27.0504 800.232C-23.8559 776.467 -68.9143 743.076 -106.87 700.988C-122.482 683.677 -136.5 665.324 -148.879 646.019C-114.001 667.83 -68.1558 691.456 -12.1404 709.736C82.5391 740.635 182.427 748.559 284.946 733.355C288.409 768.798 288.111 794.492 287.162 810.331C286.576 820.107 285.683 827.299 284.952 832.003C251.626 838.462 217.598 840.836 183.23 839.064C128.778 836.256 76.2316 823.192 27.0504 800.232Z' fill='%23FCF2D3'/%3E%3C/svg%3E%0A") center/cover no-repeat;
        animation: animRotate 15s linear infinite;

        @include below($mobile) {
            width: 440px;
            height: 440px;
            left: -70px;
            top: -250px;
        }
    }

    @keyframes animRotate {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    &__container {
        position: relative;
        display: flex;
        padding: 170px 0;
        z-index: 1;

        @include below($mobile) {
            flex-direction: column;
            padding: 80px 0;
        }
    }

    &__left {
        width: 55%;
        order: 1;
        display: flex;
        flex-direction: column;

        @include below($mobile) {
            width: 100%;
            order: 0;
        }

        &-title {
            font-family: BOWLER, sans-serif;
            font-size: 48px;
            font-weight: 400;
            line-height: 60px;
            text-align: right;

            @include below($mobile) {
                font-family: BOWLER, sans-serif;
                font-size: 30px;
                font-weight: 400;
                line-height: 38px;
                text-align: left;
            }
        }

        &-btn {
            margin-top: 40px;
            margin-left: auto;

            @include below($mobile) {
                display: none;
            }
        }
    }

    &__right {
        width: 45%;

        @include below($mobile) {
            width: 100%;
            margin-top: 50px;
        }

        &-title {
            font-family: Montserrat, sans-serif;
            font-size: 18px;
            font-weight: 300;
            line-height: 28px;
            text-align: left;
        }

        &-list {
            position: relative;
            margin-top: 5px;

            &.animation ._box {
                animation: ease-into .6s ease-in-out;
                animation-fill-mode: forwards;
            }

            ._box {
                transform: translateX(-150%);

                @for $i from 1 to 6 {
                    $time: $i * 0.1;

                    &:nth-child(#{$i}) {
                        animation-delay: #{$time}s !important;
                    }
                }
            }

            &-el {
                display: inline-flex;
                position: relative;
                padding: 16px 0 16px 60px;
                margin-top: 20px;
                color: #000000;
                font-family: BOWLER, sans-serif;
                font-size: 20px;
                font-weight: 400;
                text-align: left;

                @include below($mobile) {
                    padding: 8px 0 8px 40px;
                    font-size: 14px;
                }

                @for $i from 1 to 6 {
                    $time: $i * 0.1;

                    &:nth-child(#{$i}) {
                        animation-delay: #{$time}s !important;
                    }
                }

                &-add {
                    margin: 20px 0 0 60px;
                    color: #6F6F6F;

                    @include below($mobile) {
                        margin: 20px 0 0 10px;
                    }
                }

                &:before {
                    position: absolute;
                    content: '';
                    width: 22px;
                    height: 16px;
                    left: 28px;
                    top: 50%;
                    transform: translateY(-50%);
                    background-image: url("data:image/svg+xml,%3Csvg width='22' height='16' viewBox='0 0 22 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M19.8212 3.24954C20.0939 2.92632 20.0497 2.44594 19.7224 2.17659C19.3951 1.90724 18.9087 1.95091 18.6359 2.27413L13.0912 8.84486C11.9775 10.1647 11.194 11.0904 10.5144 11.6964C9.85067 12.2883 9.39261 12.4764 8.94286 12.4764C8.49311 12.4764 8.03505 12.2883 7.37132 11.6964C6.69175 11.0904 5.90825 10.1647 4.79448 8.84486L3.36407 7.14976C3.09132 6.82654 2.60489 6.78287 2.27759 7.05222C1.95029 7.32157 1.90607 7.80194 2.17882 8.12516L3.64892 9.86731C4.71377 11.1292 5.56654 12.1398 6.33731 12.8272C7.13348 13.5372 7.94735 14 8.94286 14C9.93838 14 10.7522 13.5372 11.5484 12.8272C12.3192 12.1399 13.1719 11.1293 14.2368 9.86735L19.8212 3.24954Z' fill='%23FF4747' stroke='%23FF4747' stroke-width='3' stroke-linecap='round'/%3E%3C/svg%3E");

                    @include below($mobile) {
                        left: 8px;
                    }
                }

                &:after {
                    position: absolute;
                    content: '';
                    width: calc(100% + 200% + 60px);
                    height: calc(100%);
                    left: calc(-200% - 20px);
                    top: -7px;
                    border: 6px solid #FCF2D3;
                    box-shadow: 0 0 0 4px #fff;;
                    border-radius: 50px;
                }
            }
        }

        &-btn-mob {
            display: none;

            @include below($mobile) {
                display: block;
                width: calc(100% - 60px);
                margin: 40px 30px 0;
            }
        }
    }
}

@keyframes ease-into {
    0% {
        transform: translateX(-150%);
    }
    100% {
        transform: translateX(0);
    }
}
</style>